import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";
import { getUserType } from "src/utils/localStorageHelper";

export const getAttendances = ({ id, ...params }) => {
  const userType = getUserType();

  return api.get(`${userType}/attendances`, {
    params,
  });
};

export const getAttendancesQueryOptions = params => {
  return queryOptions({
    queryKey: ["attendances", params],
    queryFn: () => getAttendances(params),
  });
};

export const useAttendancesQuery = ({ queryConfig = {}, ...params }) => {
  return useQuery({
    ...getAttendancesQueryOptions(params),
    ...queryConfig,
  });
};
